import tr from "locales/tr/tr.json";
import en from "locales/en/en.json";

export const dictionaryList = { en, tr };

export const languageOptions = {
  en: "English",
  tr: "Türkçe",
};
